module.exports = __webpack_public_path__ + "static/media/bluePhone.7a436455.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bluePhone.svg
// module id = 452
// module chunks = 0